/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { TokenToken } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the feature version data.
         * @summary Get feature version data
         * @param {string} storeId The store identifier.
         * @param {string} q The query name.
         * @param {Array<string>} urlKeywordName The input urlKeyword names.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFindByUrlKeywordNames: async (storeId: string, q: string, urlKeywordName: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('tokenFindByUrlKeywordNames', 'storeId', storeId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('tokenFindByUrlKeywordNames', 'q', q)
            // verify required parameter 'urlKeywordName' is not null or undefined
            assertParamExists('tokenFindByUrlKeywordNames', 'urlKeywordName', urlKeywordName)
            const localVarPath = `/store/{storeId}/seo/token`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (urlKeywordName) {
                localVarQueryParameter['urlKeywordName'] = urlKeywordName.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the feature version data.
         * @summary Get feature version data
         * @param {string} storeId The store identifier.
         * @param {string} q The query name.
         * @param {Array<string>} urlKeywordName The input urlKeyword names.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenFindByUrlKeywordNames(storeId: string, q: string, urlKeywordName: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenFindByUrlKeywordNames(storeId, q, urlKeywordName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * Gets the feature version data.
         * @summary Get feature version data
         * @param {string} storeId The store identifier.
         * @param {string} q The query name.
         * @param {Array<string>} urlKeywordName The input urlKeyword names.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFindByUrlKeywordNames(storeId: string, q: string, urlKeywordName: Array<string>, options?: any): AxiosPromise<TokenToken> {
            return localVarFp.tokenFindByUrlKeywordNames(storeId, q, urlKeywordName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * Gets the feature version data.
     * @summary Get feature version data
     * @param {string} storeId The store identifier.
     * @param {string} q The query name.
     * @param {Array<string>} urlKeywordName The input urlKeyword names.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public tokenFindByUrlKeywordNames(storeId: string, q: string, urlKeywordName: Array<string>, options?: any) {
        return TokenApiFp(this.configuration).tokenFindByUrlKeywordNames(storeId, q, urlKeywordName, options).then((request) => request(this.axios, this.basePath));
    }
}
